module.exports = __webpack_public_path__ + "static/media/404.d9f5b7b9.svg";